import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BuyerFormApp from '../components/buyerForm/BuyerFormApp';

/** Buyer opens the private link from WhatsApp (no login). */
export function BuyerFormLinkPage() {
  const { token = '' } = useParams();
  return <BuyerFormApp mode="link" token={token} />;
}

/** Staff open the same form at the office ("Fill with buyer here") in buyer mode: no CRM menu. */
export function BuyerFormOfficePage() {
  const { projectId = '', unitId = '', bookingId = '' } = useParams();
  const navigate = useNavigate();
  const place = React.useMemo(() => ({ projectId, unitId, bookingId }), [projectId, unitId, bookingId]);
  return <BuyerFormApp mode="office" place={place} onExit={() => navigate(`/office/units/${unitId}`)} />;
}
